export default __webpack_public_path__ + "static/media/cc2021 (4).a6c71e75.jpg";